































import { defineComponent, ref } from '@vue/composition-api';

const CommonCheckboxIcon = defineComponent({
  setup(props: any, ctx: any) {
    const selected = ref(props.value);
    const selectHandler = (item: any) => {
      ctx.emit('input', item);
    };

    return {
      selected,
      selectHandler,
    };
  },
  props: {
    display: {
      type: Array,
    },
    list: {
      type: Array,
    },
    icon: {
      type: Array,
    },
    value: {
      type: String,
      default() { return ''; },
    },
  },
});

export default CommonCheckboxIcon;
